/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_WhatsappInputs */

const es_footer_whatsapp = /** @type {(inputs: Footer_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp · +34 679 855 762`)
};

const gl_footer_whatsapp = /** @type {(inputs: Footer_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp · +34 679 855 762`)
};

const en_footer_whatsapp = /** @type {(inputs: Footer_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp · +34 679 855 762`)
};

/**
* | output |
* | --- |
* | "WhatsApp · +34 679 855 762" |
*
* @param {Footer_WhatsappInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_whatsapp = /** @type {((inputs?: Footer_WhatsappInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_WhatsappInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_whatsapp(inputs)
	if (locale === "en") return en_footer_whatsapp(inputs)
	return es_footer_whatsapp(inputs)
});